<template>
    <div id="new" class="ui segment">
        <h1 class="ui header">
            新增報價單
        </h1>
        <div class="ui divider"></div>
        <div class="ui form">
            <div class="ui grid" style="margin-top:0;margin-bottom:0">
                <div class="sixteen wide field" data-column="title">
                    <label>標題</label>
                    <input type="text" v-model="quotation.title">
                </div>
                <div class="eight wide field" data-column="quoted_from">
                    <label>起</label>
                    <el-date-picker
                        style="width: 100%;"
                        v-model="quotation.quoted_from"
                        unlink-panels
                        type="date"
                        >
                    </el-date-picker>
                </div>
                <div class="eight wide field" data-column="quoted_to">
                    <label>訖</label>
                    <el-date-picker
                        style="width: 100%;"
                        v-model="quotation.quoted_to"
                        unlink-panels
                        type="date"
                        >
                    </el-date-picker>
                </div>
            </div>

            <div class="ui divider"></div>
            <a href="#" v-if="!is_loading" @click.prevent="create_quotation()" class="ui blue button">
                {{ $t('ui.general.create') }}
            </a>
            <a href="#" v-else class="ui blue button">
                {{ $t('ui.general.creating') }}...
            </a>
        </div>
    </div>
</template>

<script>
import moment from "moment"
export default {
    name: "ProviderNewQuotation",
    props: {
    },
    data() {
        return {
            is_loading: false,
            quotation: {
                quote_policy_identity: this.$route.params.quote_policy_identity,
                contract_identity: this.$route.params.contract_identity
            }
        }
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        create_quotation() {
            this.is_loading = true
            var params = this.quotation

            params.quoted_from = moment(params.quoted_from).startOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00')
            params.quoted_to = moment(params.quoted_to).endOf('day').format('YYYY-MM-DDTHH:mm:ss+08:00')

            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_quotations_create).parse()

            return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                this.is_loading = false
                if (response.data.status == "success") {
                    this.$router.go(-1)
                } else {
                    // this.$noty.error("建立客戶合約失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.create__name', {
                            name: this.$t('models.quotations')
                        })
                    )
                }
            })
            .catch(error => {
                this.is_loading = false
                this.$noty.error(
                    this.$t('ui.notifications.error.create__name', {
                        name: this.$t('models.quotations')
                    })
                )
            })
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        }
    },
    components: {
    }
}
</script>

<style lang="scss">
.ui.horizontal.divider:after, .ui.horizontal.divider:before {
    top: 0;
}
</style>
